/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon20Regular = forwardRef('ArrowFigureACircleUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 14a.75.75 0 0 1-.75-.75V8.056l-1.674 2.009a.75.75 0 0 1-1.152-.96l2.232-2.679c.7-.84 1.989-.84 2.688 0l2.232 2.679a.75.75 0 0 1-1.152.96L10.75 8.057v5.192A.75.75 0 0 1 10 14Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 17.999A7.999 7.999 0 1 1 10 2 7.999 7.999 0 0 1 10 18ZM3.501 10A6.499 6.499 0 1 0 16.5 10 6.499 6.499 0 0 0 3.5 10Z" })));
});
